if (!customElements.get('mc-review-quote')) {
  customElements.define('mc-review-quote', class extends window.MCAnimatedDetails {
    connectedCallback() {
      this.connectButtonDisclosure('.mc-quote__body', '.mc-quote__text', '[data-mc-quote-toggle]');
      this.addEventListener('click', event => {
        if (!this.summary.hidden && !event.target.closest('a,button') && !getSelection()?.toString()) this.summary.click();
      }, { signal:this.lifecycle.signal });
      this.resize = new ResizeObserver(() => {
        if (this.lastWidth === this.clientWidth) return;
        this.lastWidth = this.clientWidth;
        this.finishMotion();
        this.measureTruncation();
      });
      this.resize.observe(this);
      this.measureTruncation();
    }
    measureTruncation() {
      const line = parseFloat(getComputedStyle(this.content).lineHeight);
      const truncated = this.content.scrollHeight > Math.round(line * 4) + 1;
      this.summary.hidden = !truncated;
      this.toggleAttribute('data-truncated', truncated);
    }
    setExpanded(open) {
      const from = this.body.getBoundingClientRect().height;
      this.animation?.cancel(); this.animation = null;
      this.expanded = open;
      this.applyExpandedState();
      const to = Math.max(this.content.getBoundingClientRect().height, parseFloat(getComputedStyle(this.body).minHeight));
      this.animateHeight(from, to);
    }
    disconnectedCallback() { this.resize?.disconnect(); this.disconnectDisclosure(); }
  });
}
